import { IApplicationState } from '../../types/redux';

export function getFromDevelopersPropsCount(state: IApplicationState) {
  return state.newbuilding.fromDevelopersPropsCount;
}
